import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/50_card_back_car_sunset/50_card_back_car_sunset"
 * Contains 1 texture(s)
 */
export class CardsBacks50CardBackCarSunsetAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/50_card_back_car_sunset/50_card_back_car_sunset';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '50_car_sunset.png'
    ] as const;
}
